import { Component, inject } from '@angular/core';
import { ContractTypeUsageService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ContractTypeUsageCreateDto,
  ContractTypeUsageDto,
  ContractTypeUsageExcelDownloadDto,
  ContractTypeUsageUpdateDto,
} from '../proxy/controlling/dtos/contract-type-usage';
import { CONTRACTTYPEUSAGE_CONFIG, CONTRACTTYPEUSAGE_FIELDS } from './contract-type-usage.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-contract-type-usage',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ContractTypeUsageService, ConfirmationService],
  templateUrl: './contract-type-usage.html',
  styleUrl: './contract-type-usage.scss',
})
export class ContractTypeUsage extends BaseCrudComponent<
  ContractTypeUsageDto,
  ContractTypeUsageCreateDto,
  ContractTypeUsageUpdateDto,
  ContractTypeUsageExcelDownloadDto
> {
  service = inject(ContractTypeUsageService);
  config = CONTRACTTYPEUSAGE_CONFIG;
  fields = CONTRACTTYPEUSAGE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ContractTypeUsageDto): ContractTypeUsageUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ContractTypeUsage';
  }
}
